import { FC, useState } from "react";
import "./style.scss";
import GoBack from "../../../assets/GoBackApp.svg";
import InfoIcon from "../../../assets/InformationIcon.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import TransactionIcon from "../../../assets/UnfinishedTransactionsElementIcon.svg";
import TransactionsHistory from "../../../assets/TransactionsHistory.svg";
import Bottomsheet from "widgets/bottomsheet";
import { useBlockScrollbar } from "hooks/useBlockScrollbar";

export type PropsType = {
  type: "Deposit" | "Withdrawal";
  currency: string;
  amount: number;
  date: string;
};

const UnfinishedTransactionsElement: FC<PropsType> = ({
  type,
  currency,
  amount,
  date,
}) => {
  return (
    <div className="unfinished-transactions-element">
      <div className="unfinished-transactions-element_left">
        <img
          src={TransactionIcon}
          alt="Transaction Icon"
          style={{ rotate: type === "Deposit" ? "0deg" : "180deg" }}
        />
        <div>
          <p>
            {type === "Deposit" ? "Deposit of funds" : "Withdrawal of funds"}
          </p>
          <span>{date}</span>
        </div>
      </div>
      <p className="unfinished-transactions-element_amount">
        {type === "Deposit" ? "+" : "-"} {amount} {currency}
      </p>
    </div>
  );
};

export const UnfinishedTransactionsPage = () => {
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  const [infoModal, setInfoModal] = useState(false);

  useBlockScrollbar(infoModal, [infoModal]);

  return (
    <div className="unfinished-transactions-page">
      <div className="unfinished-transactions-page_header">
        <img
          className="go-back-unfinished-transactions"
          onClick={() => {
            navigate(PATH_LIST.home);
          }}
          src={GoBack}
          alt="Go Back"
        />
        <p>{t("unfinishedTransactions")}</p>
        <button
          className="info-icon-unfinished-transactions"
          onClick={() => {
            setInfoModal(true);
          }}
        >
          <img src={InfoIcon} alt="Info" />
        </button>
      </div>

      <div className="unfinished-transactions-page_main">
        <div className="unfinished-transactions-page_main_empty">
          <img src={TransactionsHistory} alt="TransactionsHistory" />
          <p>{t("unfinishedTransactions")}</p>
          <span>{t("unfinishedTransactionsInfo")}</span>
        </div>

        {/* {Array.from({ length: 2 }).map((_, index) => (
          <UnfinishedTransactionsElement
            key={index}
            type="Withdrawal"
            currency="USD"
            amount={1000}
            date="2025-01-01"
          />
        ))}
        {Array.from({ length: 12 }).map((_, index) => (
          <UnfinishedTransactionsElement
            key={index}
            type="Deposit"
            currency="AMD"
            amount={1000}
            date="2023-02-01"
          />
        ))} */}
      </div>

      {infoModal && (
        <Bottomsheet
          title={t("unfinishedTransactions")}
          onClose={() => setInfoModal(false)}
        >
          <p className="unfinished-transactions-bottomsheet-content">
            {t("unfinishedTransactionsInfo")}
          </p>
        </Bottomsheet>
      )}
    </div>
  );
};
